import React, { useEffect, useRef, useState } from 'react';
import api from '../api/client';

// Auto-scrolling promo banners (admin-managed), shown below Services.
// Same 2.5:1 ratio and 3.5s cadence as the app.
export default function BannerCarousel({ audience = 'customer', onSelect }) {
  const [banners, setBanners] = useState([]);
  const [index, setIndex] = useState(0);
  const trackRef = useRef(null);
  const paused = useRef(false);

  useEffect(() => {
    let alive = true;
    api.get(`/banners?audience=${audience}`)
      .then((d) => { if (alive) setBanners(d?.banners || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [audience]);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const t = setInterval(() => {
      if (paused.current) return;
      setIndex((i) => (i + 1) % banners.length);
    }, 3500);
    return () => clearInterval(t);
  }, [banners.length]);

  // Keep the scroll position in sync with the active index.
  useEffect(() => {
    const el = trackRef.current;
    if (!el || !banners.length) return;
    el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
  }, [index, banners.length]);

  if (banners.length === 0) return null;

  const onScroll = (e) => {
    const el = e.currentTarget;
    const i = Math.round(el.scrollLeft / Math.max(1, el.clientWidth));
    if (i !== index) setIndex(i);
  };

  return (
    <div style={{ marginTop: 6 }}>
      <div
        ref={trackRef}
        onScroll={onScroll}
        onPointerEnter={() => { paused.current = true; }}
        onPointerLeave={() => { paused.current = false; }}
        onTouchStart={() => { paused.current = true; }}
        onTouchEnd={() => { paused.current = false; }}
        style={{
          display: 'flex',
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          scrollbarWidth: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {banners.map((b) => (
          <button
            key={b._id}
            onClick={() => onSelect && onSelect(b.navigateTo)}
            style={{ flex: 'none', width: '100%', padding: '0 16px', scrollSnapAlign: 'start' }}
          >
            <img
              src={b.image}
              alt={b.title || 'Promotion'}
              style={{
                width: '100%',
                aspectRatio: '2.5 / 1',
                objectFit: 'cover',
                borderRadius: 'var(--r-lg)',
                background: 'var(--border)',
              }}
            />
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginTop: 10 }}>
        {banners.map((b, i) => (
          <span
            key={b._id}
            style={{
              width: i === index ? 18 : 6,
              height: 6,
              borderRadius: 'var(--r-pill)',
              background: i === index ? 'var(--primary)' : 'var(--border)',
              transition: 'width 0.25s ease, background 0.25s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
}
